export const PURCHASE_REQUISITION_TYPE_PERMISSION = {
  VIEW: 'PURCHASE_REQUISITION_TYPE_VIEW',
  ADD: 'PURCHASE_REQUISITION_TYPE_ADD',
  EDIT: 'PURCHASE_REQUISITION_TYPE_EDIT',
  DEL: 'PURCHASE_REQUISITION_TYPE_DEL',
  ADD_ACCOUNTING: 'PURCHASE_REQUISITION_TYPE_ADD_ACCOUNTING',
  DEL_ACCOUNTING: 'PURCHASE_REQUISITION_TYPE_DEL_ACCOUNTING',
};

export const ACCOUNTING_TYPE = [
  { value: 1, label: 'Phiếu nhập kho' },
  { value: 2, label: 'Phiếu xuất kho' },
  { value: 3, label: 'Phiếu yêu cầu nhập hàng (PR)' },
  { value: 4, label: 'Đơn đặt hàng (PO)' },
  { value: 5, label: 'Hóa đơn mua hàng (DO)' },
  { value: 6, label: 'Chi phí mua hàng' },
  { value: 7, label: 'Thanh toán nhà cung cấp' },
];

export const ACCOUNTING_OPTIONS = [
  { value: 1, label: 'TK Nợ' },
  { value: 2, label: 'TK Có' },
  { value: 3, label: 'TK Thuế' },
  { value: 4, label: 'TK Thuế - Bên Nợ' },
  { value: 5, label: 'TK Thuế - Bên Có' },
  { value: 6, label: 'Nợ - Phải trả nhà cung cấp' },
  { value: 7, label: 'Có - Hàng tồn kho / hàng trả NCC' },
  { value: 8, label: 'Có - Thuế GTGT đầu vào điều chỉnh' },
  { value: 9, label: 'Nợ - Chi phí mua phân bổ' },
  { value: 10, label: 'Có - Giá vốn hàng bán' },
  { value: 11, label: 'Có - Hàng đã nhận chưa hóa đơn' },
  { value: 12, label: 'Nợ - Hàng đã nhận chưa hóa đơn' },
];

export const defaultValues = {
  accounting_list: [],
};
